<p-toast></p-toast>
<div class="p-5 bg-white">
  <p-table
    #xpassDataTable
    [value]="orders"
    [lazy]="true"
    [paginator]="true"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [loading]="loading"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [rowsPerPageOptions]="[10, 25, 50]"
    [tableStyle]="{ 'min-width': '150rem' }"
    paginatorStyleClass="paginator-left"
    (onLazyLoad)="loadOrders($event)"
  >
    <ng-template pTemplate="caption">
      <div class="flex justify-content-between align-items-center mb-3">
        <h2 class="text-xl font-bold m-0">Xpass</h2>
        <div class="flex align-items-center gap-2 bg-blue-50 px-3 py-2 border-round">
          <i class="pi pi-wallet text-blue-500"></i>
          <span class="font-medium">PisoPay Wallet Balance:</span>
          <span *ngIf="isLoadingBalance" class="text-500">
            <i class="pi pi-spin pi-spinner"></i>
          </span>
          <span *ngIf="!isLoadingBalance" class="font-bold text-blue-700">{{ pisoPayWalletBalance }}</span>
        </div>
        <div class="flex align-items-center gap-2 bg-green-50 px-3 py-2 border-round">
          <i class="pi pi-ticket text-green-500"></i>
          <span class="font-medium">Total Stub Count:</span>
          <span class="font-bold text-green-700">{{ totalStubCount }}</span>
        </div>
        <div class="flex gap-2 align-items-center">
          <p-calendar [(ngModel)]="filter.startDate" 
            (onSelect)="filterTableByDateRange()" 
            (onClear)="filterTableByDateRange()" 
            placeholder="From:" 
            [showIcon]="true" 
            dateFormat="mm/dd/yy"></p-calendar>
      
          <p-calendar [(ngModel)]="filter.endDate" 
            (onSelect)="filterTableByDateRange()" 
            (onClear)="filterTableByDateRange()" 
            placeholder="To:" 
            [showIcon]="true" 
            dateFormat="mm/dd/yy"></p-calendar>

          <p-button label="Export" icon="pi pi-download" (click)="openExportSidebar()" />
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="TransferOrderId">
          Booking ID <p-sortIcon field="TransferOrderId" />
        </th>
        <th pSortableColumn="CustomerName">
          Customer Name <p-sortIcon field="CustomerName" />
        </th>
        <th pSortableColumn="Location">
          Xpass Location <p-sortIcon field="Location" />
        </th>
        <th pSortableColumn="Product">
          Xpass Product<p-sortIcon field="Product" />
        </th>
        <th pSortableColumn="TripType">
          Trip Type<p-sortIcon field="TripType" />
        </th>
        <th pSortableColumn="PickupLocation">
          Pickup Location<p-sortIcon field="PickupLocation" />
        </th>
        <th pSortableColumn="DropOffLocation">
          Drop Off Location<p-sortIcon field="DropOffLocation" />
        </th>
        <th pSortableColumn="Status">Status<p-sortIcon field="Status" /></th>
        <th pSortableColumn="IpassValid">Ipass Valid<p-sortIcon field="IpassValid" /></th>
        <th pSortableColumn="ScheduledDate">
          Scheduled Date<p-sortIcon field="ScheduledDate" />
        </th>
        <th pSortableColumn="LastUpdatedDate">
          Last Updated<p-sortIcon field="LastUpdatedDate" />
        </th>
        <th pSortableColumn="IsModified">
          Is Modified?<p-sortIcon field="IsModified" />
        </th>
        <th pSortableColumn="PassengerCount">
          Passenger Count <p-sortIcon field="PassengerCount" />
        </th>
        <th pSortableColumn="StubCount">
          Stubs Count <p-sortIcon field="StubCount" />
        </th>
      </tr>
      <tr>
        <th>
          <input
            type="text"
            class="p-inputtext p-component"
            [(ngModel)]="filterTransferOrderId"
            (ngModelChange)="applyFilter()"
            placeholder="Type here"
            style="width: 100%" />
        </th>
        <th>
          <input
            type="text"
            class="p-inputtext p-component"
            [(ngModel)]="filterCustomerName"
            (ngModelChange)="applyFilter()"
            placeholder="Type here"
            style="width: 100%" />
        </th>
        <th>
          <p-dropdown
            [(ngModel)]="filterLocation"
            [options]="locationOptions"
            optionLabel="label"
            optionValue="value"
            (onChange)="applyFilter()"
            placeholder="Select One"
            [showClear]="true"
          >
          </p-dropdown>
        </th>
        <th>
          <p-dropdown
            [(ngModel)]="filterProduct"
            [options]="productOptions"
            optionLabel="label"
            optionValue="value"
            (onChange)="applyFilter()"
            placeholder="Select One"
            [showClear]="true"
          >
          </p-dropdown>
        </th>
        <th>
          <p-dropdown
            [(ngModel)]="filterTripType"
            [options]="tripTypeLabels"
            (onChange)="applyFilter()"
            placeholder="Select"
            [showClear]="true"
          >
          </p-dropdown>
        </th>
        <th>
          <input
            type="text"
            class="p-inputtext p-component"
            [(ngModel)]="filterPickupLocation"
            (ngModelChange)="applyFilter()"
            placeholder="Type here"
            style="width: 100%" />
        </th>
        <th>
          <input
            type="text"
            class="p-inputtext p-component"
            [(ngModel)]="filterDropOffLocation"
            (ngModelChange)="applyFilter()"
            placeholder="Type here"
            style="width: 100%" />
        </th>
        <th>
          <p-dropdown
            [(ngModel)]="filterStatus"
            [options]="statusLabels"
            (onChange)="applyFilter()"
            placeholder="Select One"
            [showClear]="true"
          >
          </p-dropdown>
        </th>

         <th>
           <p-dropdown
            [options]="isIpassValidOptionsLabel"
            placeholder="Select"
            [(ngModel)]="filterIpassValid"
            (onChange)="applyFilter()"
            [showClear]="true"
          ></p-dropdown>
        </th>

        <th>
          <p-calendar
            [showIcon]="true"
            placeholder="Select Date"
            dateFormat="mm/dd/yy"
            [(ngModel)]="filterScheduledDate"
            [showClear]="true"
            (onSelect)="applyFilter()"
            (onClear)="applyFilter()"
          />
        </th>

        <th>
          <p-calendar
            [showIcon]="true"
            placeholder="Select Date"
            dateFormat="mm/dd/yy"
            [(ngModel)]="filterLastUpdatedDate"
            [showClear]="true"
            (onSelect)="applyFilter()"
            (onClear)="applyFilter()"
          />
        </th>

        <th>
          <p-dropdown
            [options]="isModifiedOptionsLabel"
            placeholder="Select"
            [(ngModel)]="filterIsModified"
            (onChange)="applyFilter()"
            [showClear]="true"
          ></p-dropdown>
        </th>

        <th>
          <input
            type="text"
            class="p-inputtext p-component"
            [(ngModel)]="filterPassengerCount"
            (ngModelChange)="applyFilter()"
            placeholder="Type here"
            style="width: 100%" />
        </th>
        <th>
          <input
            type="text"
            class="p-inputtext p-component"
            (input)="onChangeHeaderFilterInput($event, 'StubCount')"
            placeholder="Type here"
            style="width: 100%" />
        </th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-index="rowIndex"
      let-transaction
      let-editing="editing"
    >
      <tr (click)="openPartnerFinanceTransactionDetailSideBar(transaction)" style="cursor:pointer;">
        <td>
          {{ transaction.TransferOrderId }}
        </td>
        <td>
          {{ transaction.CustomerName }}
        </td>
        <td>
          {{ transaction.Location }}
        </td>
        <td>
          {{ transaction.Product }}
        </td>
        <td>
          {{ transaction.TripType }}
        </td>
        <td class="break-all">
          <p>{{ transaction.PickupLocation }}</p>
          <p class="text-xs text-[#BDBDBD]">
            {{ transaction.SubPickupLocation }}
          </p>
        </td>
        <td class="break-all">
          <p>{{ transaction.DropOffLocation }}</p>
          <p class="text-xs text-[#BDBDBD]">
            {{ transaction.SubDropOffLocation }}
          </p>
        </td>
        <td>
          <p-tag [style]="transaction.Status | statusPillStyling">
            {{ transaction.Status }}
          </p-tag>
        </td>
        <td>
            {{ transaction.IpassValid }}
        </td>
        <td>
          {{ transaction.ScheduledDate | date : 'MM/dd/yy HH:mm' }}
        </td>
        <td>
          {{ transaction.LastUpdatedDate | date : 'MM/dd/yy HH:mm' }}
        </td>
        <td>
          {{ transaction.IsModified }}
        </td>
        <td>
          {{transaction.PassengerCount}}
        </td>
        <td>
          {{transaction.StubCount}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="100%">
          <div class="empty-message">
            <img src="/XpressApp/assets/images/xpass/no-match.svg" />
            <p>We didn't find a match</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="summary">
    In total there are
    {{ totalRecords }} Bookings.
  </div>
</div>

<xpass-booking-detail 
    *ngIf="showXpassBookingDetailSideBar"
    [(showXpassBookingDetailSideBar)]="showXpassBookingDetailSideBar"
    [transaction]="selectedTransaction"
   >
</xpass-booking-detail>

<!-- Export Sidebar -->
<p-sidebar [(visible)]="showExportSidebar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="changedVisibleExportSidebar(false)"
           [style]="{width:'580px'}">
    <ng-template pTemplate="header">Export data</ng-template>

    <div class="flex flex-column mt-2">
        <label class="export-data-label mb-2">File Type</label>
        <p-dropdown [options]="exportFileTypes" placeholder="Please Select" optionLabel="name" optionValue="value" [(ngModel)]="exportData.fileType"></p-dropdown>
    </div>
    <div class="flex justify-content-end mt-4" *ngIf="!exportLoading">
        <button class="btn-darkblue" pButton label="Download" (click)="export()"></button>
    </div>
</p-sidebar>

<!-- Export Loading Dialog -->
<p-dialog
        [modal]="true"
        [closable]="false"
        [draggable]="false"
        [resizable]="false"
        [(visible)]="exportLoading"
        [style]="{ width: '425px', height: '215px' }">
    <ng-template pTemplate="header">
        <div class="text-center">Exporting...</div>
    </ng-template>
    <div class="text-center">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="4" fill="transparent" animationDuration=".5s"></p-progressSpinner>
        <p class="mt-3">Please wait while we prepare your file...</p>
    </div>
</p-dialog>
